export default __webpack_public_path__ + "static/media/check.0e163e83.png";